import { useContext } from 'react'
import { StakeholderContext } from './StakeholderContextDef'

export function useStakeholderContext() {
  const context = useContext(StakeholderContext)
  if (context === undefined) {
    throw new Error('useStakeholderContext must be used within a StakeholderProvider')
  }
  return context
}
